import { useState, useEffect } from "react";
import {
  InputGroup,
  InputLeftElement,
  Input,
  Divider,
  VStack,
  Box,
  Checkbox,
  Wrap,
  WrapItem,
  Tag,
  HStack,
  Text,
} from "@chakra-ui/react";
import { SearchIcon, CloseIcon } from "@chakra-ui/icons";
import { CustomPopover } from "../custom-popover";

interface Props {
  value: string[];
  onChange: (newValue: string[]) => void;
}

const values = ["Sales", "Marketing", "Product", "Engineering", "Design", "Finance", "HR", "Operations", "Other"];

export function JobDepartementFilter({ value, onChange }: Props) {
  const [filteredPostTopics, setFilteredPostTopics] = useState<string[]>([]);
  const [searchValue, setSearchValue] = useState<string>("");

  useEffect(() => {
    if (!searchValue) {
      setFilteredPostTopics([...values]);
    } else {
      setFilteredPostTopics(
        values.filter((p) =>
          p.toLowerCase().includes(searchValue.toLowerCase())
        )
      );
    }
  }, [searchValue]);

  return (
    <CustomPopover
      property="Departements"
      value={
        value?.length === 0
          ? "all"
          : value?.length === 1
          ? value[0]
          : value.length + " selected"
      }
      popoverBodyProps={{ p: 0, fontSize: "sm" }}
      popoverContentProps={{ borderRadius: "xl" }}
      isActive={value?.length > 0}
    >
      <VStack
        overflowY="auto"
        maxH="80"
        className="noScrollBar"
        alignItems="flex-start"
        px="4"
        py="4"
      >
        {filteredPostTopics.map((i) => (
          <Box>
            <Checkbox
              isChecked={value.includes(i)}
              onChange={(e) => {
                let newValues = [...value];
                if (e.target.checked) {
                  newValues.push(i);
                } else {
                  newValues = newValues.filter((v) => v !== i);
                }

                onChange(newValues);
              }}
            >
              {i}
            </Checkbox>
          </Box>
        ))}
      </VStack>
      <Divider />
      {value?.length > 0 ? (
        <Wrap p="3" spacing="2">
          {value.map((v) => (
            <WrapItem>
              <Tag size="sm" color="white" bg="#31C52E">
                <HStack>
                  <Text>{v}</Text>
                  <CloseIcon
                    h="2"
                    w="2"
                    cursor="pointer"
                    onClick={() => {
                      onChange([...value].filter((r) => r !== v));
                    }}
                  />
                </HStack>
              </Tag>
            </WrapItem>
          ))}
        </Wrap>
      ) : (
        <></>
      )}
    </CustomPopover>
  );
}
